import { Dialog, DialogContent,  IconButton, Typography } from '@material-ui/core'
import * as React from 'react'

import CloseIcon from '@material-ui/icons/Close';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles'
import MuiDialogTitle from '@material-ui/core/DialogTitle';


const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: 20,
    },
    closeButton: {
      position: 'absolute',
      right: 10,
      top: 10,
      color: theme.palette.grey[500],
    },
  });
  export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}
const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant={'title'}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
}

function UsePolitic(props: SimpleDialogProps) {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };
  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
       <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Cláusula de Autenticación y Obligaciones del Usuario
        </DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            Al activar el mecanismo de autenticación de esta aplicación web, usted reconoce y acepta:
    <ul>
        <li>Haber recibido las credenciales necesarias para acceder a la misma.</li>
        <li>Las políticas y normativas de seguridad de la Información de Auren.</li>
        <li>Las obligaciones que conlleva la posesión de dichas credenciales, que incluyen, pero no se limitan a:</li>
        <ul>
            <li>El deber de custodia diligente de las credenciales.</li>
            <li>La protección de la confidencialidad de las credenciales.</li>
            <li>La obligación de notificar inmediatamente en caso de pérdida de las credenciales.</li>
        </ul>
        <li>Que el incumplimiento de estas obligaciones puede resultar en la revocación del acceso a la aplicación web y posibles acciones legales.</li>
    </ul>
          </Typography>
        </DialogContent>
       
      </Dialog>
  );
}
export default UsePolitic





// WEBPACK FOOTER //
// ./src/components/molecules/UsePolitic.tsx